import React from 'react';
import { withStyles } from '@material-ui/core';
import { Grid, CircularProgress, Toolbar, Paper } from '@material-ui/core';
import AmBasketsByHourChart from './AmBasketsByHourChart';
import AmBasketsByDayChart from './AmBasketsByDayChart';
import AmBasketsByDateChart from './AmBasketsByDateChart';
import AmBasketsByKioskChart from './AmBasketsByKioskChart';
import DatePicker from 'react-datepicker';
import DatePickerInput from '../DatePickerHelper';
import ReportHelpers from '../ReportHelpers';
import RpSimpleStackedBarChart from '../components/RpSimpleStackedBarChart'
import BasketsByIndividualKioskTable from './BasketsByIndividualKioskTable';
import moment from 'moment';
import PageTitle from '../../../PageTitle';

const styles = theme => ({
    root: {
		//padding: `${theme.spacing.unit * 0}px ${theme.spacing.unit * 3}px`,
		//minWidth: "1300px"
	},
	reportArea: {
		paddingTop:`${theme.spacing() * 4}px`,
		paddingLeft: `${theme.spacing() * 3}px`,
		paddingRight: `${theme.spacing() * 3}px`,
		[theme.breakpoints.down("sm")]: {
			paddingTop: theme.spacing() * 2,
			paddingLeft: theme.spacing() * 1,
			paddingRight: theme.spacing() * 1
		}
	},
	paper: {
		padding: `${theme.spacing() * 3}px ${theme.spacing() * 2}px`,
		height: "100%",
		textAlign: "center",
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
		flexDirection: "column",
		[theme.breakpoints.down("sm")]: {
			padding: `${theme.spacing() * 1}px ${theme.spacing() * 1}px`,
		}
	},
	paperValues: {
		padding: `${theme.spacing() * 3}px ${theme.spacing() * 2}px`,
		height: "100%",
		textAlign: "left",
		display: "flex",
		justifyContent: "left",
		alignItems: "left",
		flexDirection: "column"
	},
    title: {
        fontSize: "20px",
        color: "#999999"
	},
	toFromField: {
		textAlign: "right",
		color: "#999",
		fontWeight: "bold"	
	},
	toFromFieldCaption: {
		marginRight: `${theme.spacing() * 2}px`
	},
	tableHeading: {
		marginLeft: theme.spacing() * 3
	},
    pointerCursor: {
        cursor: "pointer"
	},
	hidden: {
		display:"none"
	},
	stopClicks: {
		pointerEvents:"none"
	},
	stickyTop: {
		position: "sticky",
		top: 0,
		zIndex: 42,
		background: "#fafafa"
	},
	valueHeading: {
		fontSize:"1.5rem"
	},
	chartTitle: {
		fontSize:"1.31rem",
		marginTop: "8px",
		marginBottom: "15px",
		textAlign: "left"
	},
	valueValue: {
		fontSize:"3.5rem",
		fontWeight:"bold"
	},
	stickyBottom: {
		position: "sticky",
		bottom: 0,
		zIndex: 42,
		background: "#fafafa"
	},
	wrapper: {
		width:"100%",
		height: "600px",
		overflowY: "auto",		
		overflowX: "auto"
	},    
	loading: {
        textAlign: "center",
        padding: theme.spacing() * 2
	}, 
});

class BasketsReportComponent extends React.Component {
	constructor(props) {
		super(props);
		let dt = new Date();
		let ed = moment(dt).toDate();
		let sd =  moment(dt).subtract(7, "days").toDate();
		let md = moment(dt).subtract(3, "months").toDate();
		let xd = dt;
		this.state = { 
			maxDate: xd,
			minDate: md,
			startDate: sd, 
			endDate: ed,
			actionSelected: -1
		};
	}
	componentDidMount() {
		this.props.updateTitle("Baskets");
		this.props.getBasketsStats(this.state.startDate,this.state.endDate);
	}
	setEndDate = (date) => {
		this.setState({endDate: date});
		this.update(this.state.startDate,date);
	}
	setStartDate = (date) => {
		this.setState({startDate: date});
		this.update(date,this.state.endDate);
	}
	update = (start, end) => {
		this.props.getBasketsStats(start,end);
		//console.log("UPDATE: from = " + start + ", to = " + end);
	}
	render() {
		const { classes } = this.props;
		const { baskets, loading } = this.props.basketsReport;
		const { startDate, endDate, minDate, maxDate } = this.state;
		return (
            <div className={classes.root}>
			    <Toolbar variant="dense">
                    <Grid container justify="space-between" alignItems="center">
                        <Grid item xs={6}>
                            <PageTitle/>
                        </Grid>

						<Grid item xs={6}>
							<Grid container spacing={8} justify="flex-end" alignItems="center">
								<Grid item xs={"auto"} className={classes.toFromField}>
									<span className={classes.toFromFieldCaption}>From</span>
									<DatePicker 
										selected={startDate}
										onChange={date => this.setStartDate(date)}
										selectsStart
										minDate={minDate}
										maxDate={maxDate}
										startDate={startDate}
										endDate={endDate}
										dateFormat="dd/MM/yyyy"
										popperPlacement="bottom-end"
										showPopperArrow={false}
										customInput={<DatePickerInput />}
										/>
								</Grid>

								<Grid item xs={"auto"} className={classes.toFromField}>
								<span className={classes.toFromFieldCaption}>To</span>
									<DatePicker
										popperPlacement="bottom-end"
										selected={endDate}
										onChange={date => this.setEndDate(date)}
										selectsEnd
										startDate={startDate}
										endDate={endDate}
										minDate={startDate}
										maxDate={maxDate}
										dateFormat="dd/MM/yyyy"
										showPopperArrow={false}
										customInput={<DatePickerInput />}
										/>
								</Grid>
							</Grid>
						</Grid>
					</Grid>
                </Toolbar>
				{loading? (
					<Grid container className={classes.reportArea} >
						<Grid item xs={12} className={classes.loading}>
							<CircularProgress/>
						</Grid>
					</Grid>
				):(
					<Grid container className={classes.reportArea} spacing={1}>
						<Grid item xs={12} md={4}>
							<Paper className={classes.paperValues}>
								<div className={classes.valueHeading}>Number of orders</div>
								<div className={classes.valueValue}>{Math.round(baskets.Overall.TotalBaskets)}</div>
							</Paper>
						</Grid>
						<Grid item xs={12} md={4}>
							<Paper className={classes.paperValues}>
								<div className={classes.valueHeading}>Orders Total</div>
								<div className={classes.valueValue}>{ReportHelpers.formatCurrency(baskets.Overall.BasketsTotal)}</div>	
							</Paper>
						</Grid>
						<Grid item xs={12} md={4}>					
							<Paper className={classes.paperValues}>
								<div className={classes.valueHeading}>Average order value</div>
								<div className={classes.valueValue}>{ReportHelpers.formatCurrency(baskets.Overall.AverageBasketTotal)}</div>						
							</Paper>
						</Grid>
						<Grid item xs={12} md={6}>
							<Paper className={classes.paper}>
								<AmBasketsByDateChart data={baskets.ByDate}/>	
							</Paper>					
						</Grid>	
						<Grid item xs={12} md={6}>
							<Paper className={classes.paper}>
								<AmBasketsByHourChart data={baskets.ByHour}/>	
							</Paper>					
						</Grid>	
						<Grid item xs={12} md={6}>
							<Paper className={classes.paper}>
								<AmBasketsByDayChart data={baskets.ByDay}/>	
							</Paper>					
						</Grid>	
						<Grid item xs={12} md={6}>
							<Paper className={classes.paper}>
								<RpSimpleStackedBarChart
									classes={classes}
									heading="Baskets by Store"
									tableHeight={430}
									data={baskets.ByStore} 
									captionkey="Store" 
									valuekey="Total" 
									sortkey="Total"													
									format={(v) => ReportHelpers.formatNumber(v)}/>
							</Paper>
						</Grid>
						<Grid item xs={12} md={6}>
							<Paper className={classes.paper}>
								<AmBasketsByKioskChart data={baskets.ByKiosk}/>		
							</Paper>	
						</Grid>	
						<Grid item xs={12} md={6}>
							<Paper className={classes.paper}>
								<BasketsByIndividualKioskTable 
									classes={classes}
									heading="Baskets by Individual POS"
									data={baskets.ByIndividualKiosk}
									tableHeight={430}/>
							</Paper>
						</Grid>	
						<Grid item xs={12} style={{color:"#CCC"}} className={classes.hidden}>
							{baskets.DbMs}ms
						</Grid>	
				</Grid>)}
			</div>
		)
	}
}

export default withStyles(styles)(BasketsReportComponent);